// Persistent inline error message for form save failures (WCAG 1.4.1 / 3.3.1).
// Toasts remain supplemental, but they auto-dismiss and rely on placement/color
// alone — this renders a text error next to the control that stays until the
// next attempt succeeds. role="alert" announces it to screen readers once.
import { AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";

export function InlineFormError({
  error,
  className,
  "data-testid": testId,
}: {
  error: unknown;
  className?: string;
  "data-testid"?: string;
}) {
  if (!error) return null;
  const message =
    error instanceof Error ? error.message : typeof error === "string" ? error : "Something went wrong. Please try again.";
  return (
    <p
      role="alert"
      className={cn("flex items-start gap-1.5 text-sm text-destructive", className)}
      data-testid={testId ?? "text-inline-form-error"}
    >
      <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" aria-hidden="true" />
      <span>{message}</span>
    </p>
  );
}
